<template>
    <div class="row">
        <div class="col-md-6">
            <div class="subheader mb-2 pb-2">
                <h1 class="subheader-title">
                    <i class="subheader-icon fal fa-window"></i> JSON_IN
                </h1>
                <div class="flex_in cursor-pointer" @click="copy(editor_in)">
                    <i class="fal fa-copy fs-xxl"></i>
                </div>
            </div>

            <div class="debug_info jsoneditor_getorder">
                <div ref="jsonInContainer" class="ace-monokai" style="height: 65vh"></div>
            </div>
        </div>

        <div class="col-md-6">
            <b-overlay :show="is_load">
                <div class="subheader mb-2 pb-2">
                    <h1 class="subheader-title">
                        <i class="subheader-icon fal fa-window"></i> JSON_OUT
                    </h1>
                    <div class="flex_in cursor-pointer" @click="copy(editor_out)">
                        <i class="fal fa-copy fs-xxl"></i>
                    </div>
                </div>

                <div class="debug_info jsoneditor_getorder">
                    <div ref="jsonOutContainer" class="ace-monokai" style="height: 65vh"></div>
                </div>
            </b-overlay>
        </div>
    </div>
</template>

<script>

import JSONEditor from 'jsoneditor';

export default {
    name: "order_requests",
    props : {
        order : {
            type : Object
        }
    },
    data() {
        return {
            is_load: false,
            build: "",
        }
    },
    beforeUnmount() {
        if (this.editor_in) {
            this.editor_in.destroy();
        }
        if (this.editor_out) {
            this.editor_out.destroy();
        }
    },
    mounted() {
        this.editor_in = new JSONEditor(this.$refs.jsonInContainer, {
            mode: 'code',
            mainMenuBar: false,
            navigationBar: false,
            name: null
        });

        if (this.order.hasOwnProperty("full_inp")) {
            this.editor_in.set(this.order.full_inp);
        }

        this.load_builder();
    },
    methods : {
        async copy(editor) {
            if (!editor) {
                return;
            }

            try {
                await navigator.clipboard.writeText(editor.getText());

                EventBus.$emit('show_toast', {
                    err: 'Copied to clipboard',
                    type: "success",
                    title: 'JSON',
                    position: "b-toaster-top-left",
                });
            } catch (e) {
                console.error(e);
            }
        },

        async load_builder() {
            this.is_load = true;
            await api.get('/internal/v1/catalog/orders/' + parseInt(this.order.id) + "/build").then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.build = data.data.data;
                    this.init_out_editor();
                }
            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },

        init_out_editor() {
            try {
                this.editor_out = new JSONEditor(this.$refs.jsonOutContainer, {
                    mode: 'code',
                    mainMenuBar: false,
                    navigationBar: false,
                    name: null
                });

                this.editor_out.set(this.build);
            }
            catch (e) {
                console.log(e);
            }
        },
    },
}
</script>

<style scoped>
.jsoneditor {
    border : 0;
}
</style>
